import _, {cloneDeep} from 'lodash';
import * as actionTypes from '../../constants/actionTypes';
import * as helpers from "../../utilities/helpers";
import {getAssociatedFeaturesByNakedName} from "./ProjectScopeSelector";

const initialState = {
  fabricator: null,
  features: null,
  featureGroupMeta: null,
  featureGroups: null,
  activeFeatureGroupName: null,
  fabFeatMap: {},
  layerLookup: {},
  backingFeatureLookup: {},
  fabricatorSubscriptions: [],
  activeMode: 'All'
};

const findState = (features, state, seek) => {
  return features.filter(_ => _.fabricatorData && (_.fabricatorData[state] === seek)).length > 0;
}

/***
 *
 * @param features
 * @param featureDefinitions
 * @param layerLookup
 * @returns {*} feature definitions
 */
const processFeatureData = (features, featureDefinitions, layerLookup) => {
  if (!featureDefinitions) //QCDES-531
    return ;
  for (let i = 0; i < featureDefinitions.length; i++) {
    const featData = featureDefinitions[i];
    featData.hideFromFrontEnd = featData.hideFromFrontEnd || false;
    featData.imageUrl = featData.imageKey ? `https://s3.amazonaws.com/features-thumbnails/feature-${featData.imageKey}.png` : `https://gfdmigration.blob.core.windows.net/feature-images/${featData.id}.png`;
    featData.hasLayers = layerLookup[featData.id];
    featData.fabricatorData = null;
    let ff = features[featData.id]; //features.filter(_ => _.featureDefinition_id === f.id);
    if (ff) {
      ff.fabFeat_id = ff.id;
      featData.fabricatorData = ff;
      featData.fabricatorData.displayName = ff.displayName;
      featData.hideFromFrontEnd = ff.hideFromFrontEnd || false;
      featData.unlocked = ff.unlocked || false;
    }
  }
  return featureDefinitions;
}

const complexGroups = {
};
// const complexGroups = {
//   'wall a': 'Walls', 'wall b': 'Walls', 'wall c': 'Walls', 'ex r': 'Walls', 'ex l': 'Walls', 'accent wall': 'Walls',
//   'pony wall': 'Walls', 'shower wall': 'Walls'
// };

const featureRegex = /(.*?s?)(?:-x)?\s*-\s*([\s\w]+)\s*([\[\(]+.*[]\)]+)*/i;
const processFeatureGroups = (featureDefinitions, featureGroupMeta) => {
  let featureGroups = _.uniqBy(_.map(featureDefinitions, fd => {
    let featureGroupName = fd.name.substring(0, fd.name.indexOf(' - '));
    if (featureGroupName.toLowerCase() === "cabinets") {
      featureGroupName = "cabinet";
    }
    if (_.endsWith(featureGroupName.toLowerCase(), '-x')) {
      featureGroupName = featureGroupName.substring(0, featureGroupName.length - 2);
    }
    return featureGroupName;
  }), a => a.toLowerCase());

  let featureGroupData = [];
  for (let i = 0; i < featureGroups.length; i++) {
    let featureGroup = featureGroups[i];
    if (featureGroup.length === 0) continue;
    const featureGroupLc = featureGroup.toLowerCase();
    let featureGroupsFeatures = featureDefinitions.filter(fd => {
      const match = featureRegex.exec(fd.name);
      if (match && match.length >= 2) {
        fd.nakedName = match[2].toLowerCase();
        fd.originalNakedName = match[2];
        fd.nakedGroupName = match[1];
        return match[1].toLowerCase() === featureGroupLc && fd.nakedName !== 'placeholder';
      }
      return false;
    });

    let meta = _.first(featureGroupMeta.filter(_ => _.featureGroup === featureGroup));

    const complexGroup = complexGroups[featureGroupLc];
    if (complexGroup) {
      const idx = _.findIndex(featureGroupData, {name: complexGroup});
      let group;
      if (idx !== -1) {
        // a group already was created
        group = featureGroupData[idx];
      } else {
        group = {
          isComplex: true,
          name: complexGroup,
          description: helpers.getFeatureGroupDescription(complexGroup),
          subGroups: {},
          mergedUniqueFeatures: []
        };
        featureGroupData.push(group);
      }

      group.mergedUniqueFeatures = _.unionBy(group.mergedUniqueFeatures, featureGroupsFeatures, _ => _.nakedName);
      group.subGroups[featureGroup] = {
        name: featureGroup,
        features: featureGroupsFeatures,
        enabled: meta ? meta.enabled : findState(featureGroupsFeatures, 'enabled', true),
        visible: meta ? meta.visible : findState(featureGroupsFeatures, 'hideFromFrontEnd', false),
        customDisplayName: meta ? meta.customDisplayName : null,
        customDescription: meta ? meta.customDescription : null,
        unitText: meta ? meta.unitText : null,
        customImageUrl: meta ? meta.customImageUrl : null
      }
    } else {
      //const groupedNames = _.groupBy(featureGroupsFeatures, _ => getGroupAbleName(_.originalNakedName));
      featureGroupData.push({
        isComplex: false,
        name: featureGroup,
        description: helpers.getFeatureGroupDescription(featureGroup),
        features: featureGroupsFeatures,
        enabled: meta ? meta.enabled : findState(featureGroupsFeatures, 'enabled', true),
        visible: meta ? meta.visible : findState(featureGroupsFeatures, 'hideFromFrontEnd', false),
        customDisplayName: meta ? meta.customDisplayName : null,
        customDescription: meta ? meta.customDescription : null,
        unitText: meta ? meta.unitText : null,
        customImageUrl: meta ? meta.customImageUrl : null
        //groupedNames
      });
    }

  }
  const featureGroupDataOrdered = _.orderBy(featureGroupData, ['name'], ['asc']);
  // console.log("featureGroupDataOrdered", featureGroupDataOrdered);

  return featureGroupDataOrdered;
};

const consolidateFeatures = (features) => {
  const featuresByName = {};
  features && features.forEach(f => {
    const nameKey = f.name.toLowerCase();
    if (!featuresByName[nameKey])
      featuresByName[nameKey] = [];
    if (f.fabricatorData)
      featuresByName[nameKey].unshift(f);
    else
      featuresByName[nameKey].push(f);
  });
  let _features = [];
  for (const key in featuresByName) {
    const fbn = featuresByName[key];
    const tFeat = fbn[0];
    tFeat.backingFeatures = fbn;
    tFeat.selectedUnit = tFeat.unit;
    tFeat.unitOptions = _.map(fbn, f => f.unit);
    _features.push(tFeat);
  }

  for (let n = 0; n < _features.length; n++) {
    if (_features[n].id === 2485) {
      const backingIndex = _.findIndex(_features[n].backingFeatures, bf => bf.id === _features[n].id && bf.fabricatorData);
      if (backingIndex > -1)
        _features[n].fabricatorData = _features[n].backingFeatures[backingIndex].fabricatorData;
    }
  }

  return _features;
}

const processComplexGroups = (state) => {
  const {featureGroups} = state;
  _.forEach(_.filter(featureGroups, fg => fg.isComplex),
    fg => {
      fg.mergedUniqueFeatures = _.orderBy(fg.mergedUniqueFeatures, ['nakedName'], ['asc']);
      _.forEach(fg.mergedUniqueFeatures, muf => {
        const associatedFeatures = getAssociatedFeaturesByNakedName({
          featureDefinitions: state.featureDefinitions,
          fabricator: state.fabricator,
          fabFeatMap: state.fabFeatMap},
          muf.nakedName);
        const getCost = f => f.fabricatorData ? f.fabricatorData.cost : null;
        const getUnlocked = f => f.fabricatorData ? f.fabricatorData.unlocked : null;
        muf.onePrice = true;
        muf.unlocked = false;
        muf.complex = true;
        if (_.some(associatedFeatures)) {
          const firstCost = getCost(associatedFeatures[0]);
          muf.onePrice = _.every(associatedFeatures, af => getCost(af) === firstCost);
          muf.unlocked = _.every(associatedFeatures, af => getUnlocked(af))
        }
      })
    });
  return featureGroups;
}

function loadState(state, {fabricator, features, featureGroupMeta, featureDefinitions, featureLayerList}) {
  state.fabricator = fabricator;
  state.layerLookup = {};
  featureLayerList && featureLayerList.forEach(fll => fll.ids.forEach(id => {
    if (!state.layerLookup[id])
      state.layerLookup[id] = {kv3: false, brv: false};
    state.layerLookup[id][fll.bucketName] = true;
  }));

  state.fabFeatMap = {};
  features && features.forEach(f => state.fabFeatMap[f.featureDefinition_id] = f);
  state.featureDefinitions = featureDefinitions;
  state.features = consolidateFeatures(processFeatureData(state.fabFeatMap, featureDefinitions, state.layerLookup));
  state.featureGroups = processFeatureGroups(state.features, featureGroupMeta);

  // console.log('xxx', _.filter(featureDefinitions, fd => state.fabFeatMap[fd.id] && state.fabFeatMap[fd.id].fabricator_id === fabricator.id && fd.nakedName === 'grecian'));
  // console.log('yyy', _.filter(featureDefinitions, fd => state.fabFeatMap[fd.id] && state.fabFeatMap[fd.id].fabricator_id === fabricator.id && fd.name.toLowerCase().indexOf('grecian') !== -1));
  processComplexGroups(state);

  return state;
}

export default function projectScopeReducer(state = initialState, action) {
  let newState = {...state};
  switch (action.type) {
    case actionTypes.ProjectScope.DATA_LOADED:
      newState = loadState(newState, action.payload);
      break;
    case actionTypes.ProjectScope.SET_ACTIVE_GROUP:
      newState.activeFeatureGroupName = action.payload;
      break;
    case actionTypes.ProjectScope.FABRICATOR_SUBSCRIPTIONS_LOADED:
      newState.fabricatorSubscriptions = action.payload;
      break;
    case actionTypes.ProjectScope.UPDATE_FEATURE_GROUPS:
      newState.featureGroups = (newState.featureGroups || []).map((featureGroup) => {
        if (featureGroup.name === action.payload.updatedFeatureGroup.name) {
          return action.payload.updatedFeatureGroup
        }
        return featureGroup
      });
      break;
    case actionTypes.ProjectScope.ADD_NEW_FEATURE_GROUP:
      newState.featureGroups = [action.payload.newFeatureGroup, ...newState.featureGroups];
      break;
    case actionTypes.ProjectScope.SET_MODE:
      newState.activeMode = action.payload;
      break;
  }
  return newState;
}
